import React from 'react';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { guaranteeSteps } from '../data/content';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="w-full bg-white px-4 py-14 md:py-20" data-id="element-130" data-mp="223y639n82bl6">
      <div className="mx-auto grid max-w-5xl items-center gap-8 md:grid-cols-[auto_1fr] md:gap-12" data-id="element-131" data-mp="221bw73cuzjzs">
        <div className="mx-auto flex h-40 w-40 flex-col items-center justify-center rounded-full border-[6px] border-gold bg-navy text-center text-white sm:h-48 sm:w-48" data-id="element-132" data-mp="1x28vtw7tq1y5">
          <ShieldCheckIcon className="h-10 w-10 text-gold" aria-hidden="true" data-id="element-133" data-mp="14h8vwcid8so8" />
          <span className="mt-1 font-display text-5xl font-extrabold leading-none" data-id="element-134" data-mp="1j5lu7g4xenlw">7</span>
          <span className="font-display text-base font-bold uppercase tracking-wide" data-id="element-135" data-mp="1edk8z4ps5mjq">Day guarantee</span>
        </div>
        <div data-id="element-136" data-mp="qmydecwypuqm">
          <h2 className="text-center font-display text-[2.1rem] font-extrabold uppercase leading-[1.02] text-navy sm:text-5xl md:text-left" data-id="element-137" data-mp="qmevuxb858d4">
            Explore the blueprint for 7 days, risk-free
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-138" data-mp="oxfbid54svu5">
            I want you to have the opportunity to explore the material and decide whether it fits your educational
            needs. After purchasing, take the time to:
          </p>
          <ul className="mt-4 space-y-2.5" data-id="element-139" data-mp="12r6airl8kxbm">
            {guaranteeSteps.map(s => <li key={s} className="flex items-center gap-3" data-id="element-140" data-mp="61716ux9hurz">
                <CheckIcon className="h-5 w-5 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-141" data-mp="62qfifzcxvr4" />
                <span className="text-base text-ink" data-id="element-142" data-mp="b1laegalnarl">{s}</span>
              </li>)}
          </ul>
          <p className="mt-4 text-base leading-relaxed text-muted" data-id="element-143" data-mp="k0f5214ddr2i">
            If, within seven days of your purchase, you decide the material isn't right for you, contact our support
            team and request a refund according to the published refund policy.
          </p>
        </div>
      </div>
      <CTAButton className="mt-10" label="Try it risk-free for 7 days" subtext="Your purchase is protected" data-id="element-144" data-mp="3riqf0o7x3luc" />
    </section>;
}